import React, { Component , useEffect } from 'react'
import { FaPlus } from "react-icons/fa6";
import {
  MDBCol,
  MDBRow
} from "mdb-react-ui-kit";
import { FaUserTie } from "react-icons/fa6";
import { PiUsersThreeThin } from "react-icons/pi";
import { HiOutlineBuildingLibrary } from "react-icons/hi2";

function CA_total_Count({ interval }) {
  
    return (
    <>
      <div className='mt-5'>
        {/* ---------------------------Mobile View------------------------- */}
        <div className='d-sm-block pb-2 mb-5 pt-4 d-md-none total_count_background'>
        <div className='container'>
          <MDBRow className="d-flex justify-content-center">
          <MDBCol md="10" xl="8" className="text-center mobile_total_component_text">
              <h1 className="">Our Reach</h1>
          </MDBCol>
          </MDBRow>
          <div class="container">
          <div className='row'>
          <div class="col-6">
              <div className='text-center'>
              <h1 className="mobile_Total_num" data-val="40">20K<FaPlus size="30px" color="black" /></h1>
              <p className="Total_text">Colleges</p>
              </div>
          </div>
          <div class="col-6">
              <div className='text-center'>
              <h1 className="mobile_Total_num" data-val="50">50<FaPlus size="30px" color="black" /></h1>
              <p className="Total_text">Mentors</p>
              </div>
          </div>
          <div class="col-12">
              <div className='text-center'>
              <h1 className="mobile_Total_num" data-val="10">20K<FaPlus size="30px" color="black" /></h1>
              <p className="Total_text">Campus Ambassador</p>
              </div>
          </div>
          </div>
          </div>
          </div>
        </div>

        {/* ---------------------------Dasktop View------------------------- */}
        <div className='d-none d-md-block total_count_background mb-5'>
        <div className='container'>
          <MDBRow className="d-flex justify-content-center">
          <MDBCol md="10" xl="8" className="text-center pt-5 total_component_text">
              <h1 className="display-5">Our Reach</h1>
          </MDBCol>
          </MDBRow>
          <div class="pb-4 pt-3 container">
          <div className='row'>
          <div className='d-flex justify-content-evenly'>
          <div class="">
              <div className='text-center'>
              <HiOutlineBuildingLibrary size="50px" color="black" />
              <h1 className="pt-2 Total_num" data-val="40">20K<FaPlus size="35px" color="black" /></h1>
              <p className="Total_text">Colleges</p>
              </div>
          </div>
          <div class="">
              <div className='text-center'>
              <FaUserTie size="50px" color="black" />
              <h1 className="Total_num pt-2" data-val="50">20K<FaPlus size="35px" color="black" /></h1>
              <p className="Total_text">Campus Ambassador</p>
              </div>
          </div>
          <div class="">
              <div className='text-center'>
              <PiUsersThreeThin size="50px" color="black" />
              <h1 className="Total_num pt-2" data-val="10">50<FaPlus size="35px" color="black" /></h1>
              <p className="Total_text">Mentors</p>
              </div>
          </div>
          </div>
          </div>
          </div>
          </div>
        </div>
      </div>
      </>
    );
  }
  
  export default CA_total_Count;


